export default "const context = canvas.getContext('2d')\nconst myImage = document.getElementById('myImageId')\ncontext.drawImage(myImage, 0, 0)";